export const getAuthenticationMethod = () => {
    return {
        authenticationMethod: "true-auth"
    };
};
//# sourceMappingURL=get-authentication-method.js.map